import { Box, Text } from '@bpba/ui-components';
import { IconType } from 'react-icons';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

type MenuItemProp = {
  children: React.ReactNode;
  route?: string;
  selected?: boolean;
  isTransparent?: boolean;
  onClick?: () => void;
  Icono?: IconType;
};

export const MenuItem = ({ children, route, selected, onClick, Icono }: MenuItemProp) => {
  const navigate = useNavigate();
  return (
    <StyledBox
      backgroundColor={selected ? 'primary.0' : 'secondary.2'}
      alignItems={'center'}
      onClick={() => (onClick ? onClick() : navigate(route!))}
      color={selected ? 'white' : 'secondary.1'}
      p={'8px'}
      borderRadius={'4px'}
      fontWeight={'500'}
      width={'fit-content'}
    >
      <StyledText textAlign="center" fontSize={'12px'}>
        {children}
      </StyledText>
      {Icono && <Icono size={22} />}
    </StyledBox>
  );
};

const StyledBox = styled(Box)({
  ':hover': {
    cursor: 'pointer',
  },
  whiteSpace: 'nowrap',
});

const StyledText = styled(Text)({
  whiteSpace: 'nowrap',
  userSelect: 'none',
});
